import logo from '../../assets/logo.png'
import { Link } from 'react-router-dom'
import { useUserAuth } from '../../context/UserAuthContext'
import './header.css'
const Header = () => {
    const { language, setLanguage } = useUserAuth()
    const languageHandler = (lang) => {
        setLanguage(lang)
    }
    return (
        <nav className="navbar" style={{ background: '#f6fbff', justifyContent: "right" }}>
            <div className="container vendor_header_style">
                <div>
                    <Link className="navbar-brand" to="/">
                        <img src={logo} style={{ height: "40px" }} className='logo_size' />
                    </Link>
                </div>
                <div className='d-flex'>
                    <div className='lang_box' style={{ borderRadius: '50px', background: "var(--main-btn-color)", height: "35px" }}>
                        <button className={`btn text-white ${language === 'en' ? 'bg-success' : null}`} style={{ borderRadius: '50px', marginRight: '5px', height: '35px', border: "none" }} onClick={() => languageHandler('en')}>English </button>
                        <button className={`btn text-white ${language === 'hi' ? 'bg-success' : null}`} style={{ borderRadius: '50px', height: '35px', border: "none" }} onClick={() => languageHandler('hi')}>Hindi</button>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Header